import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

// import { Container, TextField } from '@mui/material';
// import Grid from '@mui/material/Grid';

import { fixUpperCaseandUnderscore } from '../../../Utils/Utils';

export default function AddCompanyDialogeBox(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));


    const mappedAddObject = () =>{
        return(
            Object.keys(props.hqCompanyObject).map((keyer, i) => {

                if(typeof(props.hqCompanyObject[keyer])==="object"){
                    return(
                        Object.keys(props.hqCompanyObject[keyer]).map((subKeyer,x)=>{
                            let newKey = fixUpperCaseandUnderscore(subKeyer);
                            return(
                                <DialogContentText key={x}>
                                    {`${newKey} : ${props.hqCompanyObject[keyer][subKeyer]} `}
                                    {/* <p>
                                    <span style={{mr:"2vh"}}>{`${newKey} `}</span>
                                    <span>{` : ${props.hqCompanyObject[keyer][subKeyer]}`}</span>
                                    </p> */}
                                </DialogContentText>
                            )
                        })

                    )
                }else{
                    
                    let newKey = fixUpperCaseandUnderscore(keyer);
                    // keyer
                    return(
                        <DialogContentText key={i}>
                            {`${newKey} : ${props.hqCompanyObject[keyer]}`}
                            {/* <p >
                            {newKey}
                            <span style={{mr:"2vh"}}>{newKey}</span>
                            <span>{`: ${props.hqCompanyObject[keyer]}`}</span>
                            </p> */}
                        </DialogContentText>
                    )
                }
            })
        );
    };

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={props.confirmationDialogeBoxOpen}
        onClose={props.handleConfirmDialogeBoxClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {`Do you want to proceed with adding the ${props.addWhatCompanyType}?`}
        </DialogTitle>
        <DialogContent>
            {mappedAddObject()}
        </DialogContent>
        
        <DialogActions>
          <Button autoFocus onClick={(e)=>{props.dialogeConfirmationBoxAnswerHandle("Disagree")}}>
            Disagree
          </Button>
          <Button onClick={(e)=>{props.dialogeConfirmationBoxAnswerHandle("Agree")}} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}